import React from "react";
import "./app-checkbox.component.scoped.scss";
import clsx from "clsx";
import { Checkbox, FormControlLabel, Typography, Box } from "@material-ui/core";
import { AppCheckboxProps } from "./app-checkbox.types";

const AppCheckboxComponent: React.FC<AppCheckboxProps> = ({
  label,
  showInfoIcon = false,
  infoIcon,
  className,
  checked,
  ...checkboxProps
}) => {
  const checkbox = (
    <Checkbox
      checked={checked}
      className={clsx("checkbox__root", className)}
      checkedIcon={<span className={clsx("checkbox__icon", "checked")} />}
      icon={<span className="checkbox__icon" />}
      {...checkboxProps}
    />
  );

  if (!label) {
    return (
      <label
        className={clsx(
          "app__checkbox__component d-flex align-items-center justify-content-center",
          `size__${checkboxProps.size ?? "small"}`,
        )}
        style={{ cursor: checkboxProps.disabled ? "default" : "pointer" }}
      >
        {checkbox}
      </label>
    );
  }

  return (
    <FormControlLabel
      className={clsx(
        "app__checkbox__component",
        `size__${checkboxProps.size ?? "small"}`,
      )}
      control={checkbox}
      label={
        <Box className="checkbox__label">
          <Typography variant="body1" color="textPrimary">
            {label}
          </Typography>
          {showInfoIcon && infoIcon && <img src={infoIcon} alt="info" />}
        </Box>
      }
    />
  );

  // return (
  //   <FormControlLabel
  //     className={clsx(
  //       "app__checkbox__component",
  //       `size__${checkboxProps.size ? checkboxProps.size : "small"}`,
  //     )}
  //     control={
  //       <Checkbox
  //         checked={checked}
  //         className="checkbox__root"
  //         checkedIcon={<span className={clsx("checkbox__icon", "checked")} />}
  //         icon={<span className="checkbox__icon" />}
  //         {...checkboxProps}
  //       />
  //     }
  //     label={
  //       label ? (
  //         <Box className="checkbox__label">
  //           <Typography variant="body1" color="textPrimary">
  //             {label}
  //           </Typography>

  //           {showInfoIcon && infoIcon && <img src={infoIcon} alt="info" />}
  //         </Box>
  //       ) : null
  //     }
  //   />
  // );
};

export default AppCheckboxComponent;
